import { createContext } from 'react';

import type { BreadcrumbPartType } from '../types';

type State = {
  breadcrumbs?: readonly BreadcrumbPartType[];
  loading: boolean;
};

const BreadcrumbContext = createContext<State>({
  loading: false,
});
BreadcrumbContext.displayName = 'BreadcrumbContext';

export { BreadcrumbContext };
